import { render } from "./Index.vue?vue&type=template&id=d4ed6b1c"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Pages/Booking/Processing/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d4ed6b1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d4ed6b1c', __exports__)) {
    api.reload('d4ed6b1c', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=d4ed6b1c", () => {
    api.rerender('d4ed6b1c', render)
  })

}


export default __exports__